// import '@ant-design/compatible/assets/index.css';


import { useQuery } from 'react-query';
import React, { useEffect } from 'react';

import { Spin, Row, Select, Col } from 'antd';
import DF from 'DisplayFramework';
import FormInput from 'components/FormInput';
import Form, { FormInstance } from 'antd/lib/form';
import TextArea from 'antd/lib/input/TextArea';
import ParListSelect from 'components/ParListSelect/ParListSelect';
import { findFinModificationByAnyRefOrStatus } from 'services/fincontract';

export type TabFinModificationReviewProps = {
  objectid?: number;
  subentityid?: number;
  form?: FormInstance;
  setSuccessful?: any;
  entityReference?: string;
  onSelect?: any;
  handleModid?: (item: any) => void;
  modId?: any;
  isTab?: any;
  dataModid?: number;
};
const TabFinModificationRestore = ({
  objectid,
  subentityid,
  setSuccessful,
  entityReference,
  onSelect,
  modId,
  form,
}: TabFinModificationReviewProps) => {
  const fieldName = 'finmodifications';

  const {
    data: modList,
    refetch,
    isFetching,
  } = useQuery(['findFinModificationByAnyRefOrStatus', entityReference], () =>
    findFinModificationByAnyRefOrStatus({
      ctreference: '',
      modevent: '',
      modstatus: 'VALID',
      modtype: 'EVENT',
      ctrid: objectid ?? 0,
    })
      .then((res) => {
        const rawData: any = res.list;
        const maxModIdsArray: any = Object.values(
          rawData.reduce((acc: any, item: any) => {
            const { ctreference, modid, eventlabel, modevent, ctrid } = item;

            if (!acc[ctreference] || modid > acc[ctreference].modid) {
              acc[ctreference] = {
                ctreference,
                modid,
                eventlabel,
                modevent,
                ctrid,
              };
            }

            return acc;
          }, {})
        );
        return maxModIdsArray;
      })
      .catch((err) => [])
  );

  const handleSelectChange = (value: any) => {
    const selectedCtRid = modList.find((e: any) => e.modid === value);

    form?.setFieldValue('ctrid', selectedCtRid?.ctrid);

    form?.setFieldValue('modevent', selectedCtRid?.modevent);

  };

  useEffect(() => {
    setSuccessful && setSuccessful(isFetching);
  }, [isFetching, objectid]);

  useEffect(() => {



    if (modList){
      let modid =modList?.length > 0 ? modList[0]?.modid : 0;
      form?.setFieldsValue({
        event: 'tabfinmodificationrestore',
        modevent: modList?.map((e: any) => e.modevent),
        modid:modid
      });
      handleSelectChange(modid);
    }    

  }, [modList]);

  const optionModListValid = modList?.map((e: any, index: number) => (
    <Select.Option key={index} value={e.modid}>
      {e.ctreference + ' - ' + e.modid + ' - ' + e.eventlabel}
    </Select.Option>
  ));



  const initialValues = {
    modid: 0,
    reason: '',
    comment: '',
  };

  return (
    <DF.Provider pagcode="tabfinmodificationrestore">
      <Form form={form}>
        <Spin spinning={isFetching} delay={500}>
          <Row gutter={30} style={{ marginTop: 40, marginBottom: 30 }}>
            <Col span={10}>
              <FormInput col md={24} name="modid" labelAlign="left">
                <Select
                  allowClear
                  style={{ width: '100%' }}
                  onChange={handleSelectChange}
                  onClear={() => {
                    form?.resetFields();
                  }}
                  disabled
                >
                  {optionModListValid}
                </Select>
              </FormInput>

              <FormInput col md={24} name="reason">
                <ParListSelect parcode="RESTREASON" />
              </FormInput>
            </Col>

            <Col span={14}>
              <FormInput
                col
                md={24}
                name="comment"
                rules={[{ required: true }]}
              >
                <TextArea rows={3} />
              </FormInput>
            </Col>
          </Row>
        </Spin>
      </Form>
    </DF.Provider>
  );
};
export default TabFinModificationRestore;
